var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 64,
    viewBox: "0 0 74 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57666 31.6444C5.57322 25.3668 7.45655 19.2283 10.99 14C0.910015 24.761 0 62 0 62H28C21.4874 59.9073 15.8132 55.8458 11.7866 50.3948C7.76002 44.9438 5.58672 38.3816 5.57666 31.6444Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4623 15.628C62.2404 10.1791 57.4152 5.82473 51.6266 3.14236C48.7083 1.77204 45.5997 0.836973 42.4027 0.367779C40.9992 0.145085 39.5812 0.0234703 38.1597 0.00389938C33.8486 -0.062271 29.5669 0.714303 25.5616 2.2888C21.5564 3.8633 17.907 6.20454 14.8241 9.1774C11.7412 12.1503 9.28583 15.6959 7.59966 19.6096C5.91349 23.5233 5.02993 27.7276 5 31.9799H55.3161C55.3161 31.9799 55.9156 26.6354 56.2385 25.1571C57.5529 19.1076 59.0057 17.7885 59.0057 17.7885C64.1249 28.523 69.4517 32.2983 69.6592 32.4347C69.5503 39.0034 67.375 45.3764 63.434 50.6728C59.4931 55.9692 53.9812 59.9273 47.6603 62H73.9483C73.9483 62 75.1935 29.0688 65.4623 15.628Z",
    fill: "#3098F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 32C69.9747 36.7886 68.8036 41.5072 66.5776 45.7893C64.3516 50.0714 61.1306 53.8018 57.1648 56.6908C53.199 59.5798 48.595 61.5497 43.7104 62.4475C38.8258 63.3453 33.792 63.1468 29 61.8675",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35L38.0226 46L42 45.9771",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 50C31 50 37.9889 54.2604 45 50.345",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace3);
export default __webpack_public_path__ + "static/media/face3.7a9fd3ad67707ffa9d61a0ad438e19c7.svg";
export { ForwardRef as ReactComponent };